exports = module.exports = require("../node_modules/.pnpm/css-loader@2.1.1_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../node_modules/.pnpm/css-loader@2.1.1_webpack@4.47.0/node_modules/css-loader/dist/cjs.js!./assets/css/common.css"), "");

// Module
exports.push([module.id, "\n#app {\r\n  font-family: Noto Sans S Chinese-Bold, Noto Sans S Chinese;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  text-align: center;\r\n  min-width: 1260px;\r\n  overflow-x: hidden;\r\n  overflow: auto;\n}\r\n", ""]);

